import _ from 'lodash'
import { addCartTag } from '~/utils/criteo'
import { pushGtmData, pushGtmListData } from '~/utils/gtm'
import { rules } from '~/mixin/common/product/productRules'

const spbkMixin = {
  mixins: [rules],
  data () {
    return {
      isAddingToCart: false // 중복 클릭 방지 플래그
    }
  },
  methods: {
    getOrMdiaCd () { // 주문매체코드(CD_00074) 조회 [10:PC, 20:모바일웹, 30:모바일앱]
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.includes('app_daiso')) {
        return '30'
      }

      return /iphone|ipad|ipod|android/i.test(ua) ? '20' : '10'
    },
    async addSpbk (pd) { // 장바구니 단건 추가
      /*  pd = {
            spbkSeCd: [필수] 장바구니구분코드(CD_00097) [01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량구매],
            chnlCd: [필수] 채널코드,
            orMdiaCd: [필수] 주문매체코드
            pdNo: 상품번호,
            onldPdNo: 온라인전용상품번호,
            bunPdNo: 묶음상품번호,
            spbkQy: [필수] 장바구니수량,
            inflPath: 유입경로,
                        mbMngNo: 회원관리번호
          }
      */

      const prd = _.cloneDeep(pd)

      const userTy = this.$store.getters['session/getUserTy'] // 사용자유형(CD_00166) 조회 [10:개인-일반, 21:개인-미성년(14세미만), 22:개인-미성년(19세미만), 30:개인-외국인, 40:기업, 50:비회원]
      prd.chnlCd = (userTy === '40') ? '02' : '01' // 채널코드 [01:B2C, 02:B2B] - 기업회원(40)인 경우 채널코드 B2B(02)
      prd.orMdiaCd = this.getOrMdiaCd() // 주문매체코드

      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!prd?.mbMngNo) {
        prd.mbMngNo = mbMngNo
      }

      let result = { /* row: 등록건수(-1:최대 등록건수 초과), maxCont:최대 등록건수, pdNoList:등록된 상품번호목록  */ }
      console.log('장바구니 추가::addSpbk(/or/api/insSpbk)::req', prd)
      await this.$AxiosBuilder
        .data(prd)
        .build()
        .post('/or/api/insSpbk')
        .then((response) => {
          console.log('장바구니 추가 response ==={}', response)
          const res = response.data
          if (res.success) {
            console.log('<<<', res?.data)
            result = res?.data
          } else {
            console.log('<<< [Error] 장바구니 추가::', res?.message)
          }
          // 헤더 장바구니 갯수 호출
          this.$nuxt.$emit('getCartNum')
        })
        .catch((err) => {
          console.log(err)
        })

      this.$blux.basicEventSend('addCart', prd) // BLUX 정보 전달
      pushGtmData(prd, 'cart') // 장바구니 추가 성공시 GTM DataLayer Push 실행

      // Criteo 파라미터 세팅
      const tagItem = {
        prodList: prd,
        email: ''
      }

      addCartTag(tagItem)
      this.callAirBridgeForOrderAddedToCart(prd, true) // 에어브릿지 - 장바구니 담기

      return result
    },

    async addOptSpbk (pdList) {
      // pdList = [{
      //          spbkSeCd: 장바구니구분코드(CD_00097) [01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량구매],
      //          chnlCd: 채널코드,
      //          orMdiaCd: 주문매체코드
      //          pdNo: 상품번호,
      //          onldPdNo: 온라인전용상품번호,
      //          spbkQy: 장바구니수량,
      //          inflPath: 유입경로,
      //          mbMngNo: 회원관리번호
      // }]

      const mbMngNo = this.$store.getters['session/getMbMngNo']
      const userTy = this.$store.getters['session/getUserTy'] // 사용자유형(CD_00166) 조회 [10:개인-일반, 21:개인-미성년(14세미만), 22:개인-미성년(19세미만), 30:개인-외국인, 40:기업, 50:비회원]

      pdList.forEach((row) => {
        row.chnlCd = (userTy === '40') ? '02' : '01' // 채널코드 [01:B2C, 02:B2B] - 기업회원(40)인 경우 채널코드 B2B(02)
        row.orMdiaCd = this.getOrMdiaCd() // 주문매체코드

        if (!row?.lsUpdrId) {
          row.lsUpdrId = mbMngNo
        }

        if (!row?.mbMngNo) {
          row.mbMngNo = mbMngNo
        }
      })

      let result /* row: 등록건수(-1:최대 등록건수 초과), maxCont:최대 등록건수, pdNoList:등록된 상품번호목록  */
      console.log('장바구니 추가::addOptSpbk(/or/api/insOptSpbkList)::req', pdList)
      await this.$AxiosBuilder
        .data(pdList)
        .build()
        .post('/or/api/insOptSpbkList')
        .then((response) => {
          const res = response.data
          if (res.success) {
            console.log('<<<', res?.data)
            result = res?.data
          } else {
            console.log('<<< [Error] 장바구니 추가::', res?.message)
          }
          // 헤더 장바구니 갯수 호출
          this.$nuxt.$emit('getCartNum')
        })
        .catch((err) => {
          console.log(err)
        })

      this.$blux.basicEventSend('addCart', pdList) // BLUX 정보 전달
      pushGtmListData(pdList, 'cart')// 장바구니 추가 성공시 GTM DataLayer Push 실행

      // Criteo 파라미터 세팅
      const tagItem = {
        prodList: pdList,
        email: ''
      }

      addCartTag(tagItem)
      this.callAirBridgeForOrderAddedToCart(pdList, true) // 에어브릿지 - 장바구니 담기

      return result
    },

    async addSpbkList (prdList) { // 장바구니 다건 추가
      /*  prd = {
            spbkSeCd: 장바구니구분코드,
            chnlCd: 채널코드,
            pdNo: 상품번호,
            onldPdNo: 온라인전용상품번호,
            bunPdNo: 묶음상품번호,
            sleUtpc: 판매단가,
            spbkQy: 장바구니수량,
            cpnNo: 쿠폰번호,
            cpnIssuNo: 쿠폰발급번호,
            lsUpdrId: 화면ID(최종수정자아이디)
          }
      */

      const mbMngNo = this.$store.getters['session/getMbMngNo']
      const userTy = this.$store.getters['session/getUserTy'] // 사용자유형(CD_00166) 조회 [10:개인-일반, 21:개인-미성년(14세미만), 22:개인-미성년(19세미만), 30:개인-외국인, 40:기업, 50:비회원]
      prdList.forEach((row) => {
        row.chnlCd = (userTy === '40') ? '02' : '01' // 채널코드 [01:B2C, 02:B2B] - 기업회원(40)인 경우 채널코드 B2B(02)
        row.orMdiaCd = this.getOrMdiaCd() // 주문매체코드

        if (!row?.lsUpdrId) {
          row.lsUpdrId = mbMngNo
        }

        if (!row?.mbMngNo) {
          row.mbMngNo = mbMngNo
        }
      })

      let result // 등록건수(-1:최대 등록건수 초과
      console.log('장바구니 다건 추가::addSpbk(/or/api/insSpbkList)::req', prdList)
      await this.$AxiosBuilder
        .data(prdList)
        .build()
        .post('/or/api/insSpbkList')
        .then((response) => {
          const res = response.data
          console.log('<<<', res?.data)
          result = res?.data
        })
        .catch((err) => {
          console.log(err)
        })

      this.$blux.basicEventSend('addCart', prdList) // BLUX 정보 전달
      pushGtmListData(prdList, 'cart') // 장바구니 추가 성공시 GTM DataLayer Push 실행

      // Criteo 파라미터 세팅
      const tagItem = {
        prodList: prdList,
        email: ''
      }

      addCartTag(tagItem)
      this.callAirBridgeForOrderAddedToCart(prdList, false) // 에어브릿지 - 장바구니 담기

      return result
    },
    setShoppingbagCode (product) {
      if (product.spbkSeCd) {
        return product
      }
      if (product.pkupDdcatYn === 'Y' || product.pkupOrPsblYn === 'Y') { // 매장픽업
        product.spbkSeCd = '02'
      } else if (product.fdrmOrPsblYn === 'Y') { // 정기배송
        product.spbkSeCd = '01'
      } else if (product.massOrPsblYn === 'Y') {
        product.spbkSeCd = '04'
      } else if (product.quickOrPsblYn === 'Y') {
        product.spbkSeCd = '05'
      }
      if (product.pdsOrPsblYn === 'Y') { // 택배 가능여부
        product.spbkSeCd = '01'
      }
      if (product.fbYn) { // 정기배송 전문관
        product.spbkSeCd = '01'
      }
      if (product.isBulkOrderUnit) {
        product.spbkSeCd = '04'
        product.htrkCnvMummQy = (product.htrkCnvMummQy ?? product.HTRK_CNV_MUMM_QY)
        product.jpQy = (product.jpQy ?? product.JP_QY)
      }
      if (this.$route.path === '/ds/rank/pickup') { // 랭킹 - 매장픽업탭
        product.spbkSeCd = '02'
      }
      return product
    },
    clickAddSpbkBtn: _.debounce(async function (obj, chkValue = false) { // [장바구니 담기] 버튼 클릭
      // 중복 클릭 방지
      if (this.isAddingToCart) {
        console.log('장바구니 추가 처리 중... 중복 클릭 무시')
        return false
      }

      this.isAddingToCart = true

      try {
        console.log('obj ==={}', obj)
        console.log('obj.pkgYn ===', obj.pkgYn, 'obj.pkgEpieceSleYn ===', obj.pkgEpieceSleYn)
        /*
        prd = {
              spbkSeCd: [필수] 장바구니구분코드 [01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량구매],
              chnlCd: [필수] 채널코드,
              orMdiaCd: [필수] 주문매체코드
              pdNo: 상품번호,
              onldPdNo: 온라인전용상품번호,
              bunPdNo: 묶음상품번호,
              spbkQy: [필수] 장바구니수량,
              onlyOnlYn: 온라인전용상품여부,
              pkupDdcatYn: 매장전용상품여부
            }
        */

        if (!obj.spbkSeCd) {
          obj = this.setShoppingbagCode(obj)
        }

        const mbMngNo = this.$store.getters['session/getMbMngNo']
        // clickAddSpbkBtn
        if (!mbMngNo) { // 로그인 안했을때
          const returnUrlPath = this.$route.fullPath // 기획요청 [DRN-764]
          this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: returnUrlPath } })
          return
        }

        if (obj?.buyLmtAgeCd === '03' && obj?.adltCtfcYn !== 'Y') {
          if (mbMngNo !== undefined && (obj?.adltCtfcCd === '02' || obj?.adltCtfcCd === '03')) { // 로그인 되어있고 미인증인경우
            const msg = obj?.adltCtfcCd === '02' ? this.$t('PD.CERTIFY_ADULT') : this.$t('PD.CERTIFY_ADULT_EXPIRED')
            if (await this.confirm(msg, { center: true, dangerouslyUseHTMLString: true })) {
              const nowPath = this.$route.fullPath
              this.$router.push({ // 모바일 성인인증 주소 확인해야함
                name: 'mb-mbc-SCR_MBC_0110A_01',
                path: '/mb/mbc/SCR_MBC_0110A_01',
                params: { redirectUrl: nowPath } // redirectUrl: 인증완료 후 리턴할 상품화면
              })
            } else { return '' }
            return ''
          }
        }

        if (obj?.optPdYn === 'Y') { // 상품 옵션이 있을때
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: obj.recmYn ? 'Y' : 'N' } })

          return
        }
        /*
        * 낱개판매여부 N이면 상품상세로 이동. 낱개단위 구매불가
        *
        */
        if (obj?.epieceSleYn === 'N') {
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: obj.recmYn ? 'Y' : 'N' } })

          return
        }
        console.log('obj?.htrkCnvMummQy ==={}', obj?.htrkCnvMummQy)
        // 묶음 상품인경우 ... 별도로 지정해야...
        const prd = {
          pdNo: this.getPdNo(obj), // 상품번호,
          onldPdNo: this.getOnlinePdNo(obj), // 온라인전용상품번호,
          bunPdNo: obj.bunYn === 'Y' ? obj.pdNo : '', // 묶음상품번호,
          spbkQy: this.getSpbkQy(obj), // [필수] 장바구니수량
          price: obj?.price ? obj.price : obj.pdPrc ? obj.pdPrc : '', // 상품 가격
          exhPdNm: obj?.exhPdNm ?? obj.exhPdNm, // GTM 작업을 위한 파라미터 추가
          onlSclCd: obj?.ONL_SCL_CD ? obj?.ONL_SCL_CD : obj?.onlSclCd ? obj?.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
          brndNm: obj.brndNm, // GTM 작업을 위한 파라미터 추가
          optCn: obj.optCn ? obj.optCn : '', // GTM 작업을 위한 파라미터 추가
          pkgYn: this.isBoxGoods(obj) ? 'Y' : 'N',
          cartReferrer: obj.cartReferrer
        }
        // 추천 상품리스트에서 장바구니 아이콘 글릭시 장바구니 구분코드를 인식하지 못하는 문제가 있음,
        // 추천 상품리스트에서 장바구니에 담을시 장바구니 구분코드를 파라미터로 셋하도록 변경적용
        if (this.isNotEmpty(obj.spbkSeCd)) {
          prd.spbkSeCd = obj.spbkSeCd
          if (obj?.spbkSeCd === '03') {
            prd.spbkSeCd = '01'
          }
        } else {
          prd.spbkSeCd = (obj.pkupDdcatYn === 'Y' ? '02' : '01') // 장바구니구분코드 = 픽업전용여부 ? 매장픽업 : 택배배송
        }
        console.log('prd Values ==={}', prd)
        const result = await this.addSpbk(prd)
        this.handleCartActionResult(prd, result?.row)
        return result?.row > 0
      } finally {
        // 처리 완료 후 플래그 해제
        this.isAddingToCart = false
      }
    }, 300), // 300ms debounce
    async handleCartActionResult (prd, row) {
      if (row > 0) {
        this.$emit('added-spbk', prd.spbkSeCd) // 장바구니 추가 성공 emit 이벤트 발생
        this.$EventBus.$emit('renderSpbk', { spbkSeCd: prd.spbkSeCd }) // 장바구니에 갯수 반영
        this.$nuxt.$emit('getCartNum')

        await this.notifyCartActionResult(prd, this.$t('PD.CART_SUCCESS'))
      } else if (row < 0) {
        await this.notifyCartActionResult(prd, this.$t('OR.EXCEED_PD_CART'))
      } else {
        await this.notifyCartActionResult(prd, this.$t('OR.FAIL_PD_CART'))
      }
    },
    async notifyCartActionResult (prd, resultMessage) {
      await this.$notify({
        message: this.getSpbkNm(prd.spbkSeCd) + ' ' + resultMessage, // 담을 수 있는 상품 수를 초과했습니다.
        dangerouslyUseHTMLString: true,
        position: 'center',
        showClose: false,
        duration: 3000,
        onClick: () => { this.$notify.closeAll() }
      })
    },
    getSpbkTabNm (spbkSeCd) {
      switch (spbkSeCd) {
        case '01': // 택배배송 장바구니
          return 'tab1'
        case '02': // 매장픽업 장바구니
          return 'tab2'
        case '03':// 정기배송 장바구니
          return 'tab3'
        case '04':// 대량배송 장바구니
          return 'tab4'
      }
    },
    getSpbkNm (spbkSeCd) {
      switch (spbkSeCd) {
        case '01': // 택배배송 장바구니
          return '택배배송'
        case '02': // 매장픽업 장바구니
          return '매장픽업'
        case '03':// 정기배송 장바구니
          return '정기배송'
        case '04':// 대량배송 장바구니
          return '대량주문'
        case '05':// 오늘배송 장바구니
          return '오늘배송'
      }
      return null
    },
    /* 품번 - 박스 상품일 경우 매핑품번으로 품번을 지정한다. */
    getPdNo (info) {
      return this.isBoxGoods(info) ? (info.mappBoxPdNo || info.MAPP_BOX_PD_NO) : info.pdNo
    },
    /* 온라인전용상품번호 - 박스 상품일 경우 매핑품번으로 품번을 지정한다. */
    getOnlinePdNo (info) {
      return this.isBoxGoods(info) ? (info.mappBoxPdNo || info.MAPP_BOX_PD_NO) : info.onldPdNo ?? info.pdNo
    },
    /* 장바구니 수량 - 박스 상품일 경우 중포수량으로 지정한다. */
    getSpbkQy (info) {
      const productInfo = info
      if (this.isBoxGoods(productInfo)) {
        return (productInfo.jpQy || productInfo.JP_QY) ?? 1 // jpQy가 null일 경우 방지
      } else {
        return productInfo?.spbkSeCd !== '04' ? 1 : productInfo.htrkCnvMummQy !== undefined ? Number(productInfo.htrkCnvMummQy) * Number(productInfo.jpQy) : Number(productInfo.HTRK_CNV_MUMM_QY) * Number(productInfo.JP_QY)
      }
    },
    callAirBridgeForOrderAddedToCart (prd, isSingle) {
      const actuallySingle = !Array.isArray(prd)
      let productListInfo

      if (actuallySingle) {
        productListInfo = new this.$airbridge.OrderObject('', parseInt(prd.price * prd.spbkQy), '', prd.pdNo, prd.exhPdNm, prd.price, 'KRW', prd.spbkQy, 1, prd.onlSclCd, prd.brandNm, '')
        this.$airbridge.orderAddedToCart(productListInfo)
      } else {
        prd.forEach((item) => {
          productListInfo = new this.$airbridge.OrderObject('', parseInt(item.price * item.spbkQy), '', item.pdNo, item.exhPdNm, item.price, 'KRW', item.spbkQy, 1, item.onlSclCd, item.brndNm, '')
          this.$airbridge.orderAddedToCart(productListInfo)
        })
      }
    }
  }
}

export default spbkMixin
